/**
 *  AbstractChart, built for C3js library
 *
 **/
hrd.charts.AbstractChart = Class.extend({
	chartInstance: undefined,
	init: function(options, dynamicOptions, otherOptions) {
		this.initD3();
		options = $.extend(options, {useXs: true});
		this.settings = $.extend(true, options, otherOptions || {});
		this.dynamicOptions = dynamicOptions;
		this.$chart = $(this.settings.id);
		this.uuid = parseInt(Math.random() * 10000);
	},
	postInit: function(){
		this.doChart(this.dynamicOptions);
	},
	/**
	 * D3 'ItalianLocaleFormatter'
	 */
	initD3: function(){
		if(window['d3'] !== undefined){
			window['d3locale'] = d3.formatLocale({
				decimal: ",",
				thousands: ".",
				grouping: [3],
				currency: ["", " " + hrd.globals.prefs.tenant.currencySymbol]
			});
		}
	},
	doChart: function(dynamicOptions){
		var chartOptions = $.extend(true, {}, this.doCommonChartOptions(), this.doChartOptions());

		// adapt chartsOptions with dynamic Data

		this.chartOptions = this._adaptChartOptions(chartOptions, dynamicOptions);

		if(this.chartOptions != undefined){
			this.chartOptions.bindto = this.settings.id;
		}
		if(dynamicOptions.isEmptyChart){
			var $emptyChartMessage = $('.empty-chart-message', this.$chart);
			if(!$emptyChartMessage.exists()){
				$emptyChartMessage = $('<div class="empty-chart-message"></div>');
				this.$chart.append($emptyChartMessage);
			}
			$emptyChartMessage.css({
				width: this.chartOptions.size.width,
				height: this.chartOptions.size.height
			});
			$emptyChartMessage.html('<div class="empty-chart-message-content">' + dynamicOptions.emptyChartMessage + '</div>');
		} else {
			if(typeof this.settings.container.onDataClick === 'function'){
				var fnClick = this.settings.container.onDataClick;
				var cnt = this.settings.container;
				this.chartOptions.data.onclick = function(data, svgElement){
					fnClick.call(cnt, data, svgElement, this);
				}
			}
			if(typeof this.settings.container.onDataMouseover === 'function'){
				var fnOver = this.settings.container.onDataMouseover;
				var cnt = this.settings.container;
				this.chartOptions.data.onmouseover = function(data, svgElement){
					fnOver.call(cnt, data, svgElement, this);
				}
			}
			if(typeof this.settings.container.onDataMouseout === 'function'){
				var fnOut = this.settings.container.onDataMouseout;
				var cnt = this.settings.container;
				this.chartOptions.data.onmouseout = function(data, svgElement){
					fnOut.call(cnt, data, svgElement, this);
				}
			}
			this.chartOptions.onrendered = (() => {
				var cnt = this.settings.container;
				$.emit(cnt.settings.prefix + '-rendered');
			});
			if(typeof this.settings.container.customizeOptions === 'function'){
				this.chartOptions = this.settings.container.customizeOptions.call(this.settings.container, this.chartOptions);
			}
			this.chartInstance = c3.generate(this.chartOptions);
		}
		this.$chart.show();
	},
	doChartOptions: $.noop,
	doCommonChartOptions: function(){
		var size = this.settings.chartInfo.size || {};
		var $container = (this.settings.containerId !== undefined) ? $('fieldset', this.settings.containerId) : $(this.settings.id).parent();
		return {
			data: {
				columns: [],
				order: null
			},
			size: {
				width: size.weight || $container.width(),
				height: size.height || $container.height(),
			}
		};
	},
	_specificChartOptions: $.noop,
	_adaptSpecificChart: $.noop,
	_adaptChartOptions: function(staticOptions, dynamicOptions){
		// chart type
		this.applyChartType(staticOptions, dynamicOptions);
		// chart title
		if(dynamicOptions.titleInfo && dynamicOptions.titleInfo.show){
			staticOptions.title = {
				text: dynamicOptions.titleInfo.text,
				position: $.dashedCase(dynamicOptions.titleInfo.position),
				padding: dynamicOptions.titleInfo.padding
			}
		}

		// chart color
		if(dynamicOptions.color && dynamicOptions.color.colorScheme){
			staticOptions.color = {
				pattern: $.evaluate(dynamicOptions.color.colorScheme)
			};
		}

		this._adaptPadding(staticOptions, dynamicOptions);
		this._adaptTooltip(staticOptions, dynamicOptions);

		// data series names
		this._adaptsSerieNames(staticOptions, dynamicOptions);

		// legend
		this._adaptLegend(staticOptions, dynamicOptions);

		// axis names
		this._adaptAxis(staticOptions, dynamicOptions);


		// point config
		this._adaptPoint(staticOptions, dynamicOptions);

		// grid
		this._adaptGrid(staticOptions, dynamicOptions);

		// prepare colums
		this._dataToColumns(staticOptions, dynamicOptions);

		this._adaptSpecificChart(staticOptions, dynamicOptions);

		return staticOptions;
	},
	_adaptPadding: function(staticOptions, dynamicOptions){
		if(dynamicOptions.padding != undefined){
			staticOptions.padding = dynamicOptions.padding;
		}
	},
	_adaptsSerieNames: function(staticOptions, dynamicOptions){
		if(dynamicOptions.data && $.isArray(dynamicOptions.data.series)){
			var names = {};
			$.each(dynamicOptions.data.series, function(i, serie){
				names[serie.serieName] = serie.serieDescription;
			});
			staticOptions.data.names = names;
		}
	},
	_adaptLegend: function(staticOptions, dynamicOptions){
		staticOptions.legend = dynamicOptions.legend;
		if(dynamicOptions.legend.inset){
			staticOptions.legend.inset.anchor = $.dashedCase(dynamicOptions.legend.inset.anchor)
		}
	},
	_adaptTooltip: function(staticOptions, dynamicOptions){
		var _self = this;
		if(dynamicOptions.tooltip){
			staticOptions.tooltip = {
				show: dynamicOptions.tooltip.show,
				grouped: dynamicOptions.tooltip.grouped,
				init: {
					// used to auto open at a certain position, the tooltip //
					show: false,
					position: {
				        top: '0px',
				        left: '50px'
					}
				},
				format: {
					value: function(v, r, id, index){
						return d3locale.format(this.pattern)(this.useRatio ? r : v);
					}.bind({pattern: dynamicOptions.tooltip.formatPattern, useRatio: dynamicOptions.tooltip.useRatio}),
					title: function(x, index){
						var label = undefined;
						if(x !== undefined && index !== undefined){
							label = this.api.category(x);
							if(label == undefined){
								label = this.axis.getXAxisTickFormat()(x, index);
							}
						}
						label = _self._convertTooltipTitleLabel(label, x, index);
						return label;
					},
					name: function(name, x, index){
						var xTick = this.axis.getXAxisTickFormat()(x, index);
						return _self._convertTooltipNameLabel(name, x, index, xTick);
					}
				}
			};
			let isBarMultiColorSingleSerie = (dynamicOptions.type === 'bar') && (dynamicOptions.useMulticolor) && (!dynamicOptions.isEmptyChart) && (dynamicOptions.data.series.length === 1);
			if(isBarMultiColorSingleSerie) {
				this._barMultiColorSingleSerieTooltipContent(staticOptions, dynamicOptions);
			} else {
				this._standardTooltipContent(staticOptions, dynamicOptions);
			}
		}
	},
	_standardTooltipContent: function(staticOptions, dynamicOptions) {
		var _self = this;
		staticOptions.tooltip.contents = function (d, defaultTitleFormat, defaultValueFormat, color) {
			var $$ = this, config = $$.config,
			titleFormat = config.tooltip_format_title || defaultTitleFormat,
			nameFormat = config.tooltip_format_name || function (name) { return name; },
			valueFormat = config.tooltip_format_value || defaultValueFormat,
			text, i, title, value, name, bgcolor, headerAdded;
			var colorFormat = function(id, name, x, index){
				var xTick = this.axis.getXAxisTickFormat()(x, index);
				var bgColor = color(id);
				return _self._convertTooltipColor(bgColor, id, name, x, index, xTick);
			};
			text = `<table class="${$$.CLASS.tooltip}">`;
			for (i = 0; i < d.length; i++) {
				if (! (d[i] && (d[i].value || d[i].value === 0))) { continue; }
				if (! headerAdded) {
					title = titleFormat ? titleFormat.call($$, d[i].x, d[i].index) : d[i].x;
					text += (title || title === 0 ? `<tr><th colspan="3">${title}</th></tr>` : '');
					headerAdded = true;
				}
				name = nameFormat.call($$, d[i].name, d[i].x, d[i].index);
				value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
				bgcolor = $$.levelColor ? $$.levelColor(d[i].value) : colorFormat.call($$, d[i].id, d[i].name, d[i].x, d[i].index);

				text += `<tr class="${$$.CLASS.tooltipName}-${d[i].id}">`;
				text += `<td class="color"><span style="background-color:${bgcolor};"></span></td>`;
				text += `<td class="lable">${name}</td>`;
				text += `<td class="value">${value}</td>`;
				text += `</tr>`;
			}
			text += `</table>`;
			return text;
		};
	},
	_barMultiColorSingleSerieTooltipContent: function(staticOptions, dynamicOptions) {
		var _self = this;

		// redefine 'tooltip content' L&F
		staticOptions.tooltip.contents = function (d, defaultTitleFormat, defaultValueFormat, color) {
			var $$ = this, config = $$.config,
			titleFormat = config.tooltip_format_title || defaultTitleFormat,
			nameFormat  = config.tooltip_format_name || function (name) { return name; },
			valueFormat = config.tooltip_format_value || defaultValueFormat,
			text, i, title, value, name, bgcolor;
			var colorFormat = (d) => config.data_color(color(d.id), d);
			text = `<table class="${$$.CLASS.tooltip}">`;
			for (i = 0; i < d.length; i++) {
				if (! (d[i] && (d[i].value || d[i].value === 0))) { continue; }
				name = nameFormat.call($$, d[i].name, d[i].x, d[i].index);
				title = titleFormat ? titleFormat.call($$, d[i].x, d[i].index) : d[i].x;
				value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
				bgcolor = $$.levelColor ? $$.levelColor(d[i].value) : colorFormat.call($$, d[i]);

				text += `<tr><th colspan="3" style="white-space:nowrap;">` + name + `</th></tr>`;
				text += `<tr class="${$$.CLASS.tooltipName}-${d[i].id}">`;
				text += `	<td class="color"><span style="background-color:${bgcolor};"></span></td>`;
				text += `	<td class="label">${title}</td>`;
				text += `	<td class="value">${value}</td>`;
				text += `</tr>`;
			}
			text += `</table>`;
			return text;
		};
	},

	_convertTooltipTitleLabel: function(label, x, index){
		return label;
	},
	_convertTooltipNameLabel: function(name, x, index, xTick){
		return name;
	},
	_convertTooltipColor: function(bgColor, id, name, x, index, xTick){
		return bgColor;
	},
	_adaptAxis: function(staticOptions, dynamicOptions){
		if(dynamicOptions && dynamicOptions.axis){
			var axis = {
				rotated: dynamicOptions.axis.rotated
			};
			if(dynamicOptions.axis.x){
				axis.x = {
					type: dynamicOptions.axis.x.type,
					show: dynamicOptions.axis.x.show,
					min: this.parseFloat(dynamicOptions.axis.x.min),
					max: this.parseFloat(dynamicOptions.axis.x.max),
					label: {
						text: dynamicOptions.axis.x.label,
						position: $.dashedCase(dynamicOptions.axis.x.labelPosition)
					}
				};
				if(dynamicOptions.axis.x.padding){
					axis.x.padding = dynamicOptions.axis.x.padding;
				}

				if(dynamicOptions.axis.x.tick){
					axis.x.tick = dynamicOptions.axis.x.tick;
					if(dynamicOptions.axis.x.tick.cullingMax != undefined){
						axis.x.tick.culling = {
							max: dynamicOptions.axis.x.tick.cullingMax
						}
					}
					if(dynamicOptions.axis.x.tick.formatPattern){
						var xTick = dynamicOptions.axis.x.tick;
						var sType = (xTick.formatType) ? xTick.formatType : (dynamicOptions.data) ? dynamicOptions.data.serieType : 'indexed';
						axis.x.tick.format = this.toFormatFunction(dynamicOptions.axis.x.tick.formatPattern, sType);
					} else {
						axis.x.tick.format = function(x){
							var label = this.api.categories()[x];
							if(axis.x.tick.ellipsis > 0){
								return (label != undefined && label.length >= axis.x.tick.ellipsis) ? (label.substring(0, axis.x.tick.ellipsis) + "...") : label;
							} else {
								return label;
							}
						}
					}
				}
			}

			if(dynamicOptions.axis.y){
				axis.y = {
					show: dynamicOptions.axis.y.show,
					inner: dynamicOptions.axis.y.inner,
					min: this.parseFloat(dynamicOptions.axis.y.min),
					max: this.parseFloat(dynamicOptions.axis.y.max),
					inverted: !!dynamicOptions.axis.y.inverted,
					label: {
						text: dynamicOptions.axis.y.label,
						position: $.dashedCase(dynamicOptions.axis.y.labelPosition)
					}
				};
				if(dynamicOptions.axis.y.padding){
					axis.y.padding = dynamicOptions.axis.y.padding;
				}
				if(dynamicOptions.axis.y.tick){
					axis.y.tick = dynamicOptions.axis.y.tick;
					if(dynamicOptions.axis.y.tick.formatPattern){
						axis.y.tick.format = this.toFormatFunction(dynamicOptions.axis.y.tick.formatPattern);
					}
				}
			}

			if(dynamicOptions.axis.y2){
				axis.y2 = {
					show: dynamicOptions.axis.y2.show,
					inner: dynamicOptions.axis.y2.inner,
					min: this.parseFloat(dynamicOptions.axis.y2.min),
					max: this.parseFloat(dynamicOptions.axis.y2.max),
					inverted: !!dynamicOptions.axis.y2.inverted,
					label: {
						text: dynamicOptions.axis.y2.label,
						position: $.dashedCase(dynamicOptions.axis.y2.labelPosition)
					}
				};
				if(dynamicOptions.axis.y2.padding){
					axis.y2.padding = dynamicOptions.axis.y2.padding;
				}
				if(dynamicOptions.axis.y2.tick){
					axis.y2.tick = dynamicOptions.axis.y2.tick;
					if(dynamicOptions.axis.y2.tick.formatPattern){
						axis.y2.tick.format = this.toFormatFunction(dynamicOptions.axis.y2.tick.formatPattern);
					}
				}
			}
			staticOptions.axis = axis;
		}
	},
	_adaptPoint: function(staticOptions, dynamicOptions){
		if(dynamicOptions && dynamicOptions.point){
			staticOptions.point = {
				show: dynamicOptions.point.show,
				r: dynamicOptions.point.radius,
				focus: {
					expand: {
						enabled: dynamicOptions.point.expandableOnFocus
					}
				}
			};
			if(dynamicOptions.point.radiusExpanded != undefined){
				staticOptions.point.focus.expand.r = dynamicOptions.point.radiusExpanded;
			}
			if(dynamicOptions.point.radiusSelected != undefined){
				staticOptions.point.select = {
					r: dynamicOptions.point.radiusSelected
				};
			}
		}
	},
	_adaptGrid: function(staticOptions, dynamicOptions){
		if(dynamicOptions && dynamicOptions.data && dynamicOptions.data.grid){
			staticOptions.grid = dynamicOptions.data.grid;
		}
	},
	_dataToColumns: function(staticOptions, dynamicOptions){
		var data = dynamicOptions.data;
		var stacked = dynamicOptions.stacked;
		var columns = [];
		var colors = {};
		var classes = {};
		var axes = {};
		if(data && $.isArray(data.series) && data.series.length > 0){
			// merging for filling all series and avoid empties
			if(this.settings.useXs){
				var xs = {};
				$.each(data.series, function(i, serie){
					var xName = 'x' + i;
					xs[serie.serieName] = xName;
					var x = [];
					var y = [];
					x.push(xName);
					y.push(serie.serieName);
					$.each(serie.items, function(j, item){
						x.push(item.x);
						y.push(item.y);
					})
					columns.push(x);
					columns.push(y);
					if(serie.serieColor){
						colors[serie.serieName] = serie.serieColor;
					}
					if(serie.classes){
						classes[serie.serieName] = serie.classes;
					}
					if(serie.axesType){
						axes[serie.serieName] = serie.axesType;
					}
				});
				staticOptions.data.xs = xs;
			} else {
				// settings for 'X' category axes values, reading all x values from first serie
				var x = ['x'];
				$.each(data.series[0].items, function(i, item){
					x.push(item.x);
				})
				columns.push(x);

				$.each(data.series, function(i, serie){
					var s = [];
					s.push(serie.serieName);
					$.each(serie.items, function(i, item){
						s.push(item.y);
					})
					columns.push(s);
					if(serie.serieColor){
						colors[serie.serieName] = serie.serieColor;
					}
					if(serie.classes){
						classes[serie.serieName] = serie.classes;
					}
					if(serie.axesType){
						axes[serie.serieName] = serie.axesType;
					}
				});
				staticOptions.data.x = 'x';
			}
			if(stacked){
				var groups = [];
				$.each(data.series, function(i, serie){
					if(serie.stackable){
						groups.push(serie.serieName);
					}
				});
				staticOptions.data.groups = [groups]; // is double array
			}
		}
		this._adaptLabelFormat(staticOptions, dynamicOptions);
		staticOptions.data.colors = colors;
		staticOptions.data.classes = classes;
		staticOptions.data.columns = columns;
		staticOptions.data.axes = axes;
		//staticOptions.data.xSort = false
	},
	_adaptLabelFormat: function(staticOptions, dynamicOptions){
		if(dynamicOptions.labels != undefined){
			if(dynamicOptions.labels.labelFormatter){
				staticOptions.data.labels = {
					format: this.toFormatFunction(dynamicOptions.labels.labelFormatter)
				};
			} else {
				staticOptions.data.labels = true;
			}
		}
	},
	/* deprecated: maybe it will be useful in future for updating series data only */
	___load: function(data, options){
		this.adaptChart(data, options);
		var serie = this.adaptColumns(data, options);
		if(this.chartInstance){
			if(serie == undefined && serie.length == 0){
				console.log('There is no data to draw', serie, data);
			} else {
				this.$chart.show();
				this.chartInstance.load({
					columns: serie,
					unload: true
				});
			}
		}
	},
	/* deprecated: maybe it will be useful in future for updating series data only */
	___unload: function(){
		if(this.chartInstance){
			this.$chart.hide();
			this.chartInstance.unload();
		}
	},
	applyChartType: function(staticOptions, dynamicOptions){
		staticOptions.data.type = this.extractType(dynamicOptions);
	},
	extractType: function(dynamicOptions){
		var type;
		switch(dynamicOptions.subType){
		case 'spline':
			type = (dynamicOptions.type === 'area') ? 'area-spline' : 'spline';
			break;
		case 'step':
			type = (dynamicOptions.type === 'area') ? 'area-step' : 'step';
			break;
		default:
			type = dynamicOptions.type;
			break;
		}
		return type;
	},
	parseFloat: function(value){
		if(value != undefined){
			return parseFloat(value);
		}
	},
	toFormatFunction: function(pattern, type){
		type = type || 'indexed';
		switch (type) {
		case 'custom':
			return function(v){return hrd.utils.replaceParams(this.pattern, {value:v});}.bind({pattern: pattern});
		case 'indexed':
			return function(v){return d3locale.format(this.pattern)(v);}.bind({pattern: pattern});
		case 'timeseries':
			return function(v){return moment(v).format(this.pattern);}.bind({pattern: pattern});
		case 'category':
			switch (pattern) {
			case 'none':
				return function(v){return '';};
			case '1-letter':
				return function(v){var c = this.api.category(v); return c.substring(0, 1);};
			case '2-letters':
				return function(v){var c = this.api.category(v); return c.substring(0, 2);};
			case '3-letters':
				return function(v){var c = this.api.category(v); return c.substring(0, 3);};
			default:
				return undefined;
			}
		}
	}
});